import { useEffect, useState } from "react";
import { Fade, IconButton, Modal } from "@mui/material";
import { usePdpFocusedProduct, usePdpProduct } from "@/features/pdp/PdpContext";
import { ThumbnailGroup } from "./ThumbnailGroup";
import { CoverImage } from "@/components/CoverImage";
import React from "react";
import { ProductBadge } from "@/features/product/ProductBadge";
import { CoverVideo } from "@/components/CoverVideo";
import { CloseIcon } from "@/components/icons";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { keyboardTrigger } from "@/helpers/utils";

export const ThumbnailGallery = () => {
  const product = usePdpProduct();
  const focusedProduct = usePdpFocusedProduct();
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  // When the user selects a new products we will reset the selected image
  // to the product main one
  useEffect(() => {
    setSelectedImageIndex(0);
  }, [product]);

  const spotlightImage =
    focusedProduct != product || !product.media[selectedImageIndex]
      ? focusedProduct.media[0]
      : product.media[selectedImageIndex];

  const onThumbnailClick = (index: number) => {
    setSelectedImageIndex(index);
  };

  return (
    <div className="flex h-full">
      {spotlightImage.mediaType === "video" && (
        <Modal
          className="overflow-auto"
          role="dialog"
          aria-label="video modal popup"
          aria-modal={true}
          open={open}
          onClose={handleClose}
        >
          <Fade in={open}>
            <div className="absolute left-1/2 top-1/2 max-h-full w-full max-w-4xl -translate-x-1/2 -translate-y-1/2 transform rounded-md bg-white p-5 shadow-xl">
              <div className="flex items-start justify-between pb-4">
                <h3>{product.title}</h3>
                <IconButton
                  size="small"
                  aria-label="close modal"
                  color="inherit"
                  onClick={handleClose}
                  onKeyDown={keyboardTrigger(handleClose)}
                >
                  <CloseIcon
                    fontSize="small"
                    className="transition hover:opacity-50"
                    tabIndex={0}
                  />
                </IconButton>
              </div>
              <CoverVideo
                alt={spotlightImage.alt || `${product.title} highlight video`}
                url={spotlightImage.url}
                sources={spotlightImage.sources}
                autoPlay={false}
              />
            </div>
          </Fade>
        </Modal>
      )}
      <CoverImage
        alt={spotlightImage.alt ?? ""}
        src={spotlightImage.url}
        loading={selectedImageIndex === 0 ? "eager" : "lazy"}
      />
      {focusedProduct.badge && (
        <ProductBadge text={focusedProduct.badge} size="lg" />
      )}
      <ThumbnailGroup
        onThumbnailClick={onThumbnailClick}
        selectedIndex={selectedImageIndex}
      />
      {spotlightImage.mediaType === "video" && (
        <div className="absolute block h-full max-h-[588px] w-full">
          <IconButton
            size="large"
            aria-label="play video"
            color="inherit"
            onClick={() => setOpen(true)}
            onKeyDown={keyboardTrigger(() => setOpen(true))}
            className="group left-1/2 top-1/2 z-10 h-72 w-72 -translate-x-1/2 -translate-y-1/2 transform focus:outline-none focus-visible:ring-4 focus-visible:ring-primary-700 focus-visible:ring-opacity-75 "
          >
            <PlayCircleOutlineIcon className="h-full w-full transform text-white transition duration-500 group-hover:scale-110" />
          </IconButton>
        </div>
      )}
    </div>
  );
};
